// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"3fc0a8cc","380":"03575968","453":"79ec2a8e","541":"a5f46054","687":"2f7487be","711":"a7d94cc6"}[chunkId] + ".chunk.js";
};